(function () {
  function initGallery(root) {
    var gallery = root.querySelector('[data-ap-gallery]');
    if (!gallery) return;

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-ap-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ap-target]'));

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = Number(thumb.getAttribute('data-ap-target'));

        slides.forEach(function (slide, index) {
          slide.classList.toggle('is-active', index === target);
        });

        thumbs.forEach(function (item, index) {
          item.setAttribute('aria-selected', index === target ? 'true' : 'false');
        });
      });
    });
  }

  function initCountdown(root) {
    var countdown = root.querySelector('[data-ap-countdown]');
    if (!countdown) return;
    var output = countdown.querySelector('[data-ap-countdown-output]');
    if (!output) return;
    var rawEnd = countdown.getAttribute('data-end');
    var minutes = parseInt(countdown.getAttribute('data-minutes'), 10) || 0;
    var end = rawEnd ? new Date(rawEnd).getTime() : NaN;
    var rolling = !(Number.isFinite(end) && end > Date.now()) && minutes > 0;
    function newRollingEnd() {
      var e = Date.now() + minutes * 60000;
      try { window.localStorage.setItem('ap_cd_end', String(e)); } catch (err) {}
      return e;
    }
    if (rolling) {
      var saved = NaN;
      try { saved = parseInt(window.localStorage.getItem('ap_cd_end'), 10); } catch (err) {}
      end = (Number.isFinite(saved) && saved > Date.now()) ? saved : newRollingEnd();
    }
    if (!Number.isFinite(end) || end <= Date.now()) { countdown.hidden = true; return; }
    countdown.hidden = false;
    function update() {
      var remaining = end - Date.now();
      if (remaining <= 0) {
        if (rolling) { end = newRollingEnd(); remaining = end - Date.now(); } else { countdown.hidden = true; return; }
      }
      var h = Math.floor(remaining / 3600000), m = Math.floor((remaining % 3600000) / 60000), sec = Math.floor((remaining % 60000) / 1000);
      var parts = h > 0 ? [h, m, sec] : [m, sec];
      output.textContent = parts.map(function (v) { return String(v).padStart(2, '0'); }).join(':');
    }
    update();
    window.setInterval(update, 1000);
  }

  function initReviewsMore(root) {
    var grid = root.querySelector('[data-ap-reviews]');
    var button = root.querySelector('[data-ap-reviews-more]');
    if (!grid || !button) return;
    button.addEventListener('click', function () {
      grid.classList.remove('is-collapsed');
      button.hidden = true;
    });
  }

  // Canlı sayaçlar (simülasyon): görüntüleyen sayısı aralıkta dolaşır, sipariş sayısı ara ara +1
  function initLive(root) {
    var live = root.querySelector('[data-ap-live]');
    if (!live) return;
    var viewersEls = live.querySelectorAll('[data-ap-live-viewers]');
    var ordersEls = live.querySelectorAll('[data-ap-live-orders]');
    var min = parseInt(live.getAttribute('data-viewers-min'), 10) || 20;
    var max = Math.max(min + 1, parseInt(live.getAttribute('data-viewers-max'), 10) || min + 30);
    var viewers = min + Math.floor(Math.random() * (max - min + 1));
    var orders = parseInt(live.getAttribute('data-orders'), 10) || 0;
    function rand(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
    function set(els, value) {
      els.forEach(function (el) {
        el.textContent = String(value);
        el.classList.remove('is-flip'); void el.offsetWidth; el.classList.add('is-flip');
      });
    }
    function tickViewers() {
      var delta = rand(-4, 4) || 1;
      viewers = Math.min(max, Math.max(min, viewers + delta));
      set(viewersEls, viewers);
      window.setTimeout(tickViewers, rand(3000, 6500));
    }
    function tickOrders() {
      orders += 1;
      set(ordersEls, orders);
      window.setTimeout(tickOrders, rand(45000, 110000));
    }
    set(viewersEls, viewers); set(ordersEls, orders);
    window.setTimeout(tickViewers, rand(2500, 5000));
    window.setTimeout(tickOrders, rand(45000, 110000));
  }

  // KV "Videoyu İzleyin" → native <dialog> içinde YouTube iframe (referans: Plyr popup)
  function initVideo(root) {
    var dialog = root.querySelector('[data-ap-video-dialog]');
    var buttons = root.querySelectorAll('[data-ap-video]');
    if (!dialog || !buttons.length || typeof dialog.showModal !== 'function') return;

    var iframe = dialog.querySelector('iframe');
    var closeBtn = dialog.querySelector('[data-ap-video-close]');

    function close() {
      if (iframe) iframe.removeAttribute('src');
      if (dialog.open) dialog.close();
    }

    buttons.forEach(function (button) {
      var id = button.getAttribute('data-ap-video');
      if (!id) { button.hidden = true; return; }
      button.addEventListener('click', function () {
        if (iframe) iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        dialog.showModal();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
    dialog.addEventListener('close', close);
  }

  // Yatay scroll-snap swiper için nokta göstergesi (referans: Swiper pagination)
  function initSwiper(root) {
    var track = root.querySelector('[data-ap-swiper]');
    var dotsWrap = root.querySelector('[data-ap-swiper-dots]');
    if (!track || !dotsWrap) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) { dotsWrap.hidden = true; return; }

    var dots = slides.map(function (slide, index) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', (index + 1) + '. slayt');
      dot.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });

    function update() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var active = 0;
      slides.forEach(function (slide, index) {
        var mid = slide.offsetLeft + slide.offsetWidth / 2;
        if (Math.abs(mid - center) < Math.abs(slides[active].offsetLeft + slides[active].offsetWidth / 2 - center)) active = index;
      });
      dots.forEach(function (dot, index) { dot.classList.toggle('is-active', index === active); });
    }

    track.addEventListener('scroll', update, { passive: true });
    update();
  }

  // Öncesi/sonrası kaydırıcı: range → --pos
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-ap-ba]').forEach(function (el) {
      var range = el.querySelector('[data-ap-ba-range]');
      if (!range) return;
      var set = function () { el.style.setProperty('--pos', range.value + '%'); };
      range.addEventListener('input', set);
      set();
    });
  }

  function initReveal(root) {
    var selectors = [
      '.ap-kv-text',
      '.ap-tile',
      '.ap-bleed-text',
      '.ap-header-media-text',
      '.ap-ba-media',
      '.ap-ba-slider',
      '.ap-vs-item',
      '.ap-type',
      '.ap-modes-list li',
      '.ap-modes-media',
      '.ap-spec-media',
      '.ap-spec-list li',
      '.ap-section-head',
      '.ap-review-placeholder',
      '.ap-faq details',
      '.ap-final-inner'
    ].join(',');
    var items = Array.prototype.slice.call(root.querySelectorAll(selectors));
    if (!items.length) return;

    // ?ap-noreveal → QA/ekran görüntüsü için animasyonsuz
    var reduceMotion = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || /ap-noreveal/.test(window.location.search);
    items.forEach(function (item, index) {
      item.classList.add('ap-reveal');
      item.style.setProperty('--ap-reveal-delay', String((index % 4) * 90) + 'ms');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (item) {
      var rect = item.getBoundingClientRect();
      var isInitiallyVisible = rect.bottom > 0 && rect.top < window.innerHeight * 0.92;

      if (isInitiallyVisible) {
        item.classList.add('is-visible');
        return;
      }

      observer.observe(item);
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-ap-ready') === 'true') return;
    root.setAttribute('data-ap-ready', 'true');
    initGallery(root);
    initCountdown(root);
    initReviewsMore(root);
    initLive(root);
    initVideo(root);
    initSwiper(root);
    initBeforeAfter(root);
    initReveal(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ap-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
